<div class="form-group m-form__group row">
    <div [hidden]="!isSearchLocation" class="col-xl-{{cols}} col-lg-{{cols}}">
        <div id="type-selector" class="pac-controls">
            <div id="pac-container">
                <!-- <label *ngIf="isLabel" for=""
                    class="form-control-label {{labelFontSize}} {{labelFontSize ? 'color-black':''}}">{{label}}</label> -->
                <div class="input-group m-input-group">
                    <input type="text" class="form-control m-input input-select-textarea {{customInputClass}}" id="pac-input" [placeholder]="placeholder"
                        aria-describedby="basic-addon1">
                    <!-- <div class="input-group-append" (click)="locateMe(false, true)">
                        <span class="input-group-text" id="basic-addon1" data-container="body" data-toggle="m-tooltip"
                            data-placement="right" title="" data-original-title="Detect Current Location">
                            <img src="assets/icons/loc.png" alt="" width="15%"/>
                            Detect Current Location
                        </span>
                    </div> -->
                </div>
                <div *ngIf="helperGeoLocation" (click)="locateMe(false, true)"
                    class="button d-block font-size-18 link-text color-orange ">
                    <img src="assets/images/svg/detect-location.svg" alt="" srcset="">
                    {{'Detect current location'}}
                </div>
                <app-form-control-messages [control]="control.controls.coordinates" [name]="'Location'">
                </app-form-control-messages>
                <div *ngIf="locating && showMap">
                    <div class="m-spinner m-spinner--brand"></div>
                    <div class="m-spinner m-spinner--primary"></div>
                    <div class="m-spinner m-spinner--success"></div>
                    <div class="m-spinner m-spinner--info"></div>
                    <div class="m-spinner m-spinner--warning"></div>
                    <div class="m-spinner m-spinner--danger"></div>
                </div>
                <div id="infowindow-content" [hidden]="!showMap">
                    <span id="place-name" class="title"></span><br />
                    <span id="place-address"></span>
                    <span *ngIf="enableEnterLatLng" class="pl-4"><button class="btn btn-secondary" (click)="editLatLng()">Enter Latitude & Longitude Manually</button></span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-{{cols}} col-lg-{{cols}}" [hidden]="!isSearchLocation">
        <div id="map" [class]="mapsClass" [ngStyle]="{'height': height, 'width' : width}"></div>
        <p class="" style="font-style: italic">For Geolocation User Drag and Drop if 
            exact location is not found.</p>
    </div>
</div>

<div class="modal fade" id="latLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true" style="z-index: 1000;"> 
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Training Centre Geo Location</h5>
			</div>
			<div class="modal-body">
				<form [formGroup]="locationForm">
				<div class="form-group m-form__group row">
					<label for="tp-details" class="
							col-2 col-form-label
							field-label pr-0
						">
						Latitude:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-10">
						<input type="number" class="form-control notranslate" name="Enter Latitude"
									formControlName="lat" />
								<app-form-control-messages [control]="locationForm.controls.lat" [name]="'Latitude'">
								</app-form-control-messages>
					</div>
				</div>
                <div class="form-group m-form__group row">
					<label for="tp-details" class="
							col-2 col-form-label
							field-label pr-0
						">
						Longitude:
						<span class="mandatoryColor">*</span>
					</label>
					<div class="col-10">
						<input type="number" class="form-control notranslate" name="Enter longitude"
									formControlName="lng" />
								<app-form-control-messages [control]="locationForm.controls.lng" [name]="'longitude'">
								</app-form-control-messages>
					</div>
				</div>
			</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-next" (click)="saveLatLng()">
					Update Location
				</button>
				<button type="button" class="btn btn-cancel" data-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>